import React, { Component } from "react";
import { signInWithRedirect } from "aws-amplify/auth";
import LoaderButton from "./LoaderButton";
import "./GoogleButton.css";

export default class GoogleButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    };
  }

  handleError(error) {
    this.props.onError(error);
  }

  handleClick = async () => {
    this.setState({ isLoading: true });

    try {
      await signInWithRedirect({ provider: "Google" });
    } catch (e) {
      this.setState({ isLoading: false });
      this.handleError(e);
    }
  }

  render() {
    const buttonText = (
      <span className="GoogleButton-content">
        <span className="GoogleButton-iconBadge">
          <svg className="GoogleButton-icon" viewBox="0 0 18 18" aria-hidden="true" focusable="false">
            <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
            <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.33-1.58-5.04-3.72H.94v2.33A9 9 0 0 0 9 18z" />
            <path fill="#FBBC05" d="M3.96 10.7A5.4 5.4 0 0 1 3.68 9c0-.59.1-1.16.28-1.7V4.97H.94A9 9 0 0 0 0 9c0 1.45.34 2.82.94 4.03l3.02-2.33z" />
            <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .94 4.97L3.96 7.3C4.67 5.16 6.66 3.58 9 3.58z" />
          </svg>
        </span>
        <span>Continue with Google</span>
      </span>
    );

    return (
      <LoaderButton
        block
        bsSize="large"
        className="GoogleButton"
        text={buttonText}
        loadingText="Signing in..."
        isLoading={this.state.isLoading}
        onClick={this.handleClick}
        disabled={this.state.isLoading}
      />
    );
  }
}
